import React from 'react';
import moment from 'moment';
import { useTranslate } from 'react-admin';
import { toJsDate } from '../utils/dateUtils';
import DynamicCell from '../components/misc/DynamicCell';

const UserRoleCell = ({ role }) => {
  const translate = useTranslate();
  const roleLabel = role
    ? translate(`users.roles.${role}`, { _: role })
    : translate('users.default_role', { _: 'Kullanıcı' });
  return <span>{roleLabel}</span>;
};

const UserSalesCell = ({ userId }) => {
  const translate = useTranslate();
  return (
    <a href={`/#/sales?userID=${userId}`} style={{ color: '#1976d2', textDecoration: 'none' }}>
      {translate('users.view_sales', { _: 'Satışları Gör' })}
    </a>
  );
};

const UserEditCell = ({ userId }) => {
  const translate = useTranslate();
  const handleEdit = () => {
    window.location.href = `/#/users/${userId}`;
  };
  return (
    <button 
      onClick={handleEdit}
      style={{
        padding: '4px 8px',
        backgroundColor: '#1976d2',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px'
      }}
    >
      {translate('ra.action.edit', { _: 'Düzenle' })}
    </button>
  );
};

export const USERS_TABLE = {
  entity: 'users',
  defaults: {
    pageSize: 25,
    visible: { id: false },
    orderBy: { field: 'createDateTime', dir: 'desc' },
    limit: 100,
  },
  columns: [
    { field: 'id', headerName: 'ID', width: 100 },
    {
      field: 'name',
      headerName: 'Name',
      width: 120,
      valueGetter: (params) => {
        const name = params.row.name || '';
        const surname = params.row.surname || '';
        return `${name} ${surname}`.trim() || 'N/A';
      },
    },
    {
      field: 'createDateTime',
      headerName: 'Date/Time',
      width: 150,
      valueGetter: (params) => {
        if (params.row.createDateTime) {
          const d = toJsDate(params.row.createDateTime);
          return d ? moment(d).format('DD/MM/YY HH:mm') : 'N/A';
        } else if (params.row.createdate) {
          return moment(params.row.createdate, 'YYYY-MM-DD').format('LL');
        }
        return 'N/A';
      },
    },
    {
      field: 'gender',
      headerName: 'Gender',
      width: 50,
      valueGetter: (params) => {
        const genderMap = {
          male: 'M',
          female: 'F',
          prefernottosay: 'PNTS',
        };
        return genderMap[params.row.gender] || 'N/A';
      },
    },
    {
      field: 'mobile',
      headerName: 'Mobile',
      width: 150,
      valueGetter: (params) => params.row.mobile || 'N/A',
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      valueGetter: (params) => params.row.email || 'N/A',
    },
    {
      field: 'crole',
      headerName: 'Role',
      width: 120,
      renderCell: (params) => <UserRoleCell role={params.row.crole} />,
      valueGetter: (params) => params.row.crole || 'User',
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 50,
      valueGetter: (params) => params.row.country || 'N/A',
    },
    {
      field: 'verified',
      headerName: 'Verified',
      width: 50,
      valueGetter: (params) => params.row.isVerified ? 'Yes' : 'No',
      renderCell: (params) => {
        const isVerified = params.row.isVerified;
        return isVerified ? (
          <span style={{ color: 'green' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-check-circle"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm3.854 4.146a.5.5 0 0 0-.708-.708L7 9.293 5.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l4-4z"
              />
            </svg>
          </span>
        ) : (
          <span style={{ color: 'red' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x-circle"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm.354 4.646a.5.5 0 0 0-.708 0L8 8.293 5.354 5.646a.5.5 0 0 0-.708.708L7.293 9l-2.647 2.646a.5.5 0 0 0 .708.708L8 9.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 9l2.647-2.646a.5.5 0 0 0 0-.708z"
              />
            </svg>
          </span>
        );
      },
    },
    {
      field: 'sales',
      headerName: 'Sales',
      disableExport: true,
      disablePrint: true,
      width: 100,
      sortable: false,
      renderCell: (params) => <UserSalesCell userId={params.row.id} />,
    },
    {
      field: 'edit',
      headerName: 'Edit',
      disableExport: true,
      disablePrint: true,
      width: 100,
      sortable: false,
      renderCell: (params) => <UserEditCell userId={params.row.id} />,
    },
  ],
};
